export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.path.startsWith('/2/documents'))
    return

  const { isNewArchiveEnabled } = useAuth()

  if (!isNewArchiveEnabled.value) {
    navigateTo('/documents', { external: true })
    return abortNavigation()
  }
})
